<template>
<v-container class="esgContainer">
    <v-row class="bodyDivider">
        <v-col cols="12" md="6" class="pl-0">
            <v-row class="countryNameBar__holder pb-5 pl-3 ">
                <v-col cols="12">
                    <country-name-bar :countryName="country.country_name" />
                </v-col>
            </v-row>
            <v-row class="accordionRow ma-0 pa-0">
                <!-- <v-expansion-panels variant="accordion" elevation=0 bg-color="transparent" hover="false">
                    <v-expansion-panel title="Environmental" text="The threat of climate change and depletion of natural resources. The main question becomes the sustainability of products, services and therefore companies." @click="changedESGMood('e')">
                    </v-expansion-panel>
                    <v-expansion-panel title="Social" text="How the company affects the wider social environment. This includes diversity, human rights, and consumer protection." @click="changedESGMood('s')">
                    </v-expansion-panel>
                    <v-expansion-panel title="Governance" text="The rights and responsibilities of the management of a company." @click="changedESGMood('g')">
                    </v-expansion-panel>
                </v-expansion-panels> -->
                <v-col cols="12" class="pl-0">
                    <div
                        class="mb-6 figureTitle"
                        :class="{ active: esgMode === 'e' }"
                        @click="changedESGMood('e')"
                    >
                        <span>Environmental</span>
                    </div>
                    <div
                        :class="{ active: esgMode === 's' }"
                        class="mb-6 figureTitle"
                        @click="changedESGMood('s')"
                    >
                        <span>Social</span>
                    </div>

                    <div
                        :class="{ active: esgMode === 'g' }"
                        class="mb-6 figureTitle"
                        @click="changedESGMood('g')"
                    >
                        <span>Governance</span>
                    </div>


                </v-col>
            </v-row>
        </v-col>
        <v-col md="6" cols="12" class="pa-0 ma-0" style="overflow-y: auto; padding-bottom: 120px !important;">
            <v-row class="esgMobileMenu">
                <v-col cols="12">
                    <v-tabs :v-model="esgMode" slider-color="#DC0028" class="esgTabsMobile" :show-arrows="false">
                        <v-tab v-for="(esgItem) in esgTitleList" :key="esgItem.code" @click="changedESGMood(esgItem.code)">
                            {{ esgItem.title }}
                        </v-tab>

                    </v-tabs>
                </v-col>
            </v-row>
            <v-row class="mobileText pa-0 ma-0" v-if="esgMode=='e'">
                <v-col cols="12">
                    <!-- <p>
                        The threat of climate change and depletion of natural resources. The main question becomes the sustainability of products, services and therefore companies.
                    </p> -->
                </v-col>
            </v-row>

            <v-row class="mobileText pa-0 ma-0" v-if="esgMode=='s'">
                <v-col cols="12">
                    <!-- <p>
                        How the company affects the wider social environment. This includes diversity, human rights, and consumer protection.
                    </p> -->
                </v-col>
            </v-row>

            <v-row class="mobileText pa-0 ma-0" v-if="esgMode=='g'">
                <v-col cols="12">
                    <!-- <p>
                        The rights and responsibilities of the management of a company.
                    </p> -->
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <span class="noDataText" v-if="dataTableContent.length === 0">No data available</span>
                </v-col>
            </v-row>
            <v-row class="pa-0 ma-0" v-if="dataTableContent.length>0">
                <v-container class="dataHolder">
                    <v-row class="dataHeader dataRow">

                        <v-col md="9" cols="8" class="leftColumn">
                            <span class="headerRowText">Indicator</span>
                        </v-col>

                        <v-col md="3" cols="4" class="rightColumn">
                            <span class="headerRowText">Ranking</span>
                            <v-tooltip v-if="!isMobile">
                                <template v-slot:activator="{ props }">
                                    <!-- <v-img v-bind="props" :src="require('@/assets/icons/atradius-info.svg')" class="info-icon" /> -->
                                    <v-img v-bind="props" :src="require('@/assets/icons/atradius-info.svg')" class="info-icon" />
                                </template>
                                <span>{{rankingTooltip}}</span>
                            </v-tooltip>

                            <v-tooltip open-on-click width="90%" class="lineItem movementInfoIcon" v-if="isMobile">
                                <template v-slot:activator="{ props }">
                                    <!-- <v-icon v-bind="props" class="lineItem movementInfoIcon">mdi-information-outline</v-icon> -->
                                    <v-img v-bind="props" :src="require('@/assets/icons/atradius-info.svg')" class="info-icon" />
                                </template>
                                <span>{{rankingTooltip}}</span>
                            </v-tooltip>
                        </v-col>

                    </v-row>
                    <v-row class="dataInfo dataRow" v-for="item in dataTableContent" :key="item.key">
                        <v-col md="9" cols="8" class="leftColumn">
                            <v-row>
                                <v-col cols="9">
                                    <span>{{item.description}}</span>
                                </v-col>
                                <v-col cols="3">
                                    <v-tooltip v-if="!isMobile" open-on-click width="90%" :text="item.tooltip" class="lineItem movementInfoIcon tooltipText">
                                <template v-slot:activator="{ props }">
                                    <!-- <v-icon v-bind="props" class="lineItem movementInfoIcon">mdi-information-outline</v-icon> -->
                                    <v-img v-bind="props" :src="require('@/assets/icons/atradius-info.svg')" class="info-icon" />
                                </template>
                            </v-tooltip>

                                    <v-tooltip open-on-click width="90%" class="lineItem movementInfoIcon" v-if="isMobile">
                                        <template v-slot:activator="{ props }">
                                            <!-- <v-icon v-bind="props" class="lineItem movementInfoIcon">mdi-information-outline</v-icon> -->
                                            <v-img v-bind="props" :src="require('@/assets/icons/atradius-info.svg')" class="info-icon" />
                                        </template>
                                        <!-- <div v-html="item.tooltip"></div> -->
                                         <span class="tooltipText">{{ item.tooltip }}</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>

                        </v-col>

                        <v-col md="3" cols="4" class="rightColumn">
                            <span>{{item.value}}</span><span class="infoScoreGrey">/{{item.count}}</span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
            <v-row>
                <span class="sourcesText">Sources: Atradius, Macrobond, European Commission INFORM, Fund for Peace, Transparency International, United Nations Development Programme, World Bank - World Governance Indicators (WGI).</span>
            </v-row>
        </v-col>
    </v-row>
</v-container>

</template>

<script lang="ts">
import {
    defineComponent,
    ref,
    computed,
    watch,
    onMounted
} from 'vue';
import store from '@/store';
import {
    get
} from 'http';
import { it } from 'node:test';
// import atradiusInfoIcon from ;
type EsgMode = 'e' | 's' | 'g';

export default defineComponent({
    name: 'ESGView',

    data() {
        return {
            isMobile: false,
            esgMode: 'e',
            dataTableContent: [] as any[],
            esgTitleList: [{
                    title: 'Environmental',
                    code: 'e'
                },
                {
                    title: 'Social',
                    code: 's'
                },
                {
                    title: 'Governance',
                    code: 'g'
                }
            ],
            rankingTooltip: 'Countries/territories are always ranked from best performing (1) to worst performing.'
        }
    },
    mounted() {

        this.changedESGMood('e');
        this.isMobile = window.innerWidth < 900;
        this.getRankingTooltip();
    },
    methods: {
      getRankingTooltip() {
        const tooltipData = store.getters['displayStoreData/toolTipData'];

        try {
            this.rankingTooltip = tooltipData.esg_modal.ranking_table_header.text;
        } catch (error) {
            // 
        }
      },
        getToolTipText(): string {

            const esgMode = this.esgMode as EsgMode;

            const tooltipTexts: Record < EsgMode, string > = {
                'e': '1. Relative exposure to natural hazard (2024) <br/> 2. INFORM: Lack of coping capacity',
                's': '1. Human Development Index (2022) <br/> 2. Fragile states index: uneven economic development (2023)',
                'g': '1. WGI: Political Stability and Absence of Violence <br/> 2. WGI: Rule of Law <br/> 3. WGI: Regulatory Quality <br/> 4. Corruption Perception Index'
            }

            const result = tooltipTexts[esgMode];

            return result;
        },
        esgIsValid() {
            const isValid = true;
            let totalChecked = 0;
            let totalFailed = 0;

            totalChecked++;
            if (this.country.esgData.environmental && this.country.esgData.environmental.inform.data.length === 0) {
                totalFailed++;
            }

            totalChecked++;
            if (this.country.esgData.environmental && this.country.esgData.environmental.re.data.length === 0) {
                totalFailed++;
            }

            totalChecked++;
            if (this.country.esgData.governance.corruption.data.length === 0) {
                totalFailed++;
            }

            totalChecked++;
            if (this.country.esgData.governance.wgi.ge.data.length === 0) {
                totalFailed++;
            }

            totalChecked++;
            if (this.country.esgData.governance.wgi.pols.data.length === 0) {
                totalFailed++;
            }



            totalChecked++;
            if (this.country.esgData.governance.wgi.rq.data.length === 0) {
                totalFailed++;
            }

            totalChecked++;
            if (this.country.esgData.social.fsi.data.length === 0) {
                totalFailed++;
            }

            totalChecked++;
            if (this.country.esgData.social.hdi.data.length === 0) {
                totalFailed++;
            }

            if (totalChecked === totalFailed) {
                console.log('ESG data is not valid');
                return false;
            } else {
                console.log('ESG data is valid');
                return true;
            }

        },
        changedESGMood(mode: string) {
            this.esgMode = mode;
            this.buildTableContent();
        },
        buildTableContent() {
            let tooltiptext = ''
            this.dataTableContent = [];
            if (this.esgMode === 'e') {

                if (this.country.esgData && this.country.esgData.environmental.re && this.country.esgData.environmental.re.data.length > 0) {
                    for (let index = 0; index < this.country.esgData.environmental.re.data.length; index++) {
                        const dataItem = this.country.esgData.environmental.re.data[index];
                        try {
                            if(dataItem.Tool_Tip && dataItem.Tool_Tip != null && dataItem.Tool_Tip != ''){
                                tooltiptext = dataItem.Tool_Tip;
                            }
                            this.dataTableContent.push({
                                key: dataItem.Index,
                                description: dataItem.Table_Text,
                                value: dataItem.Ranking_DisplayYear,
                                count: dataItem.Count,
                                tooltip: tooltiptext
                            });
                            
                        } catch (error) {
                            // console.log('error', error)
                        }

                    }
                }
                if (this.country.esgData && this.country.esgData.environmental.inform && this.country.esgData.environmental.inform.data.length > 0) {
                    for (let index = 0; index < this.country.esgData.environmental.inform.data.length; index++) {
                        const dataItem = this.country.esgData.environmental.inform.data[index];
                        try {
                            if(dataItem.Tool_Tip && dataItem.Tool_Tip != null && dataItem.Tool_Tip != ''){
                                tooltiptext = dataItem.Tool_Tip;
                                console.log('tooltiptext', tooltiptext)
                            }
                            this.dataTableContent.push({
                                key: dataItem.Index,
                                description: dataItem.Table_Text,
                                value: dataItem.Ranking_DisplayYear,
                                count: dataItem.Count,
                                tooltip: tooltiptext
                            });

                        } catch (error) {
                            console.log('error', error)
                        }

                    }
                }
            }

            if (this.esgMode == 'g') {
                if (this.country.esgData && this.country.esgData.governance) {

                    try {
                        const corruptionItem = this.country.esgData.governance.corruption; //TODO does this need to be defensive?
                        const WGI = this.country.esgData.governance.wgi;
                        if (WGI && WGI.pols.data.length > 0) {
                            for (let index = 0; index < WGI.pols.data.length; index++) {
                                const dataItem = WGI.pols.data[index];
                                this.dataTableContent.push({
                                    key: dataItem.Index,
                                    description: dataItem.Table_Text,
                                    value: dataItem.Ranking_DisplayYear,
                                    count: dataItem.Count,
                                    tooltip: dataItem.Tool_Tip
                                });
                            }
                        }

                        // rols:{
                        if (WGI && WGI.rols.data.length > 0) {
                            for (let index = 0; index < WGI.rols.data.length; index++) {
                                const dataItem = WGI.rols.data[index];
                                this.dataTableContent.push({
                                    key: dataItem.Index,
                                    description: dataItem.Table_Text,
                                    value: dataItem.Ranking_DisplayYear,
                                    count: dataItem.Count,
                                    tooltip: dataItem.Tool_Tip
                                });
                            }
                        }

                        // if (WGI && WGI.ge.data.length > 0) {
                        //     for (let index = 0; index < WGI.ge.data.length; index++) {
                        //         const dataItem = WGI.ge.data[index];
                        //         this.dataTableContent.push({
                        //             key: dataItem.Index,
                        //             description: dataItem.Table_Text,
                        //             value: dataItem.Ranking_DisplayYear,
                        //             count: dataItem.Count,
                        //             tooltip: dataItem.Tool_Tip
                        //         });
                        //     }
                        // }

                        if (WGI && WGI.rq.data.length > 0) {
                            for (let index = 0; index < WGI.rq.data.length; index++) {
                                const dataItem = WGI.rq.data[index];
                                this.dataTableContent.push({
                                    key: dataItem.Index,
                                    description: dataItem.Table_Text,
                                    value: dataItem.Ranking_DisplayYear,
                                    count: dataItem.Count,
                                    tooltip: dataItem.Tool_Tip
                                });
                            }
                        }

                        if (corruptionItem && corruptionItem.data.length > 0) {
                            for (let index = 0; index < corruptionItem.data.length; index++) {
                                const dataItem = corruptionItem.data[index];
                                this.dataTableContent.push({
                                    key: dataItem.Index,
                                    description: dataItem.Table_Text,
                                    value: dataItem.Ranking_DisplayYear,
                                    count: dataItem.Count,
                                    tooltip: dataItem.Tool_Tip
                                });
                            }
                        }

                    } catch (error) {
                        // console.log('error', error)
                    }
                }

            }

            if (this.esgMode == 's') {
                if (this.country.esgData && this.country.esgData.social) {

                    try {
                        const fsi = this.country.esgData.social.fsi; //TODO does this need to be defensive? not everyone is out to get you little constant, the world may change around you but you will always be you <3
                        const hdi = this.country.esgData.social.hdi;
                        if (hdi && hdi.data.length > 0) {
                            for (let index = 0; index < hdi.data.length; index++) {
                                const dataItem = hdi.data[index];
                                this.dataTableContent.push({
                                    key: dataItem.Index,
                                    description: dataItem.Table_Text,
                                    value: dataItem.Ranking_DisplayYear,
                                    count: dataItem.Count,
                                    tooltip: dataItem.Tool_Tip
                                });
                            }
                        }

                        if (fsi && fsi.data.length > 0) {
                            for (let index = 0; index < fsi.data.length; index++) {
                                const dataItem = fsi.data[index];
                                this.dataTableContent.push({
                                    key: dataItem.Index,
                                    description: dataItem.Table_Text,
                                    value: dataItem.Ranking_DisplayYear,
                                    count: dataItem.Count,
                                    tooltip: dataItem.Tool_Tip
                                });
                            }
                        }

                    } catch (error) {
                        // console.log('error', error)
                    }
                }

            }

        }
    },
    computed: {
        country() {
            return store.getters['countryStoreData/selectedCountry'];
        }
    },
    watch: {
        // esgMode() {
        //     // 
        // }

    }

});
</script>

<style scoped>
.figureTitle {
  font-family: 'GCO', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: -0.25px;
  margin-bottom: 10px;
  cursor: pointer;
  color: #333;
}
.figureTitle.active {
  font-weight: 500;
  color: #DC0028;
}
.esgMobileMenu {
    display: none;
}

.widgetTitle {
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    font-family: 'GCO Sans', sans-serif;
}

.esgContainer .dataHeader {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
    font-family: 'GCO Sans', sans-serif;
}

.esgContainer .dataInfo {
    font-size: 13px;
    font-weight: 400;
    line-height: 26px;
    color: #606A76;
    font-family: 'GCO Sans', sans-serif;
}

.esgContainer .dataHolder {
    background: white;
    border-radius: 8px;
    /* min-height: 300px; */
    padding: 40px 30px;
}

.esgContainer .dataHolder .dataRow {
    border-bottom: 1px solid #E7E9EE;
}

.esgContainer .dataHolder .dataRow:last-child {
    border-bottom: none;
}

.esgContainer .dataHolder .dataRow .leftColumn {
    border-right: 1px solid #E7E9EE;
}

.infoScoreGrey {
    color: #9B9B9B;

}

.sourcesText {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #606A76;
    margin-top: 18px;
    margin-left: 26px;
    height: 5%;
    font-family: 'GCO Sans', sans-serif;
}

:deep(.v-expansion-panels) {
    width: 95%;
}

:deep(.v-expansion-panel-title) {
    font-family: 'GCO', sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: -2%;
    padding-top: 12px;
    cursor: pointer;
    padding-left: 0;
}

:deep(.v-expansion-panel-title > span:hover) {
    background-color: transparent !important;
}

.accordionRow {
    display: block;

}

.mobileText {
    display: none;
}

.mobileText p {
    color: #606A76 !important;
    margin-top: 2em !important;
    margin-bottom: 2em !important;
}

.headerRowText {
    font-family: 'GCO Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    color: #333333;
    margin: 0px 12px 0px 0px;

}

.info-icon {
    width: 20px;
    height: 20px;
    display: inline-block;
    top: 5px;
}

/* Mobile media query 900 */
@media (max-width: 900px) {
    .rightColumn .headerRowText {
        width: 70%;
        display: inline-block;
    }

    .rightColumn .info-icon {
        /* display: none; */
    }

    .info-icon {
        /* display: none; */
    }

    .mobileText {
        display: block
    }

    .esgMobileMenu {
        display: block;
        font-weight: normal;
    }

    .accordionRow {
        display: none;
    }

    /* .dataHolder{
        min-height: 351px !important;
    } */

    .sourcesText {}

    .headerRowText {
        font-family: 'GCO Sans', sans-serif;
        font-size: 12px;
        font-weight: 500;
        line-height: 26px;
        color: #333333;
        margin: inherit;
    }
}

.noDataText {
    font-family: 'GCO Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #606A76;

    margin-left: 10px;
}
</style>

<style>
.keyFiguresTabsMobile .v-slide-group__prev,
.keyFiguresTabsMobile .v-slide-group__next {
    display: none !important;
}

.esgMobileMenu .v-btn__content {
    font-weight: 500;
    text-transform: capitalize !important;
}



.v-overlay--absolute.tooltipText .v-overlay__content{
    max-width: 800px !important;
}


.esgMobileMenu span{
    font-family: 'GCO Sans', sans-serif;
    color: #333;
    font-size: 16px;
    font-weight: 500;
}
</style>
